import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1614630669107-f48325791b57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxzbm93eSUyMG1vdW50YWluJTIwcGluZSUyMGZvcmVzdCUyMHJ1Z2dlZHxlbnwwfHx8fDE3ODYyMjAwNjd8MA&ixlib=rb-4.1.0&q=85";

const line = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.35 + i * 0.12 },
  }),
};

export const Hero = () => {
  const scrollToProduct = () =>
    document.getElementById("product")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="relative min-h-screen overflow-hidden flex flex-col justify-end pb-16 md:pb-24">
      <motion.div
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img src={HERO_BG} alt="Snowy mountain pine forest" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/60" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1600px] w-full px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="text-[var(--accent)] uppercase tracking-[0.4em] text-xs md:text-sm mb-6 font-semibold"
        >
          Nairobi / Kenya — Drop 01
        </motion.p>

        <h1 className="font-anton uppercase leading-[0.82] tracking-tighter text-[19vw] md:text-[15vw]">
          <span className="block overflow-hidden">
            <motion.span custom={0} variants={line} initial="hidden" animate="show" className="block">
              Full
            </motion.span>
          </span>
          <span className="block overflow-hidden">
            <motion.span
              custom={1}
              variants={line}
              initial="hidden"
              animate="show"
              className="block text-[var(--accent)]"
            >
              Send
            </motion.span>
          </span>
        </h1>

        <div className="mt-8 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.7 }}
            className="max-w-md text-[var(--text-dim)] text-base md:text-lg"
          >
            One shirt in four styles. Built for the send — heavyweight cotton with our
            signature mountain graphic.
          </motion.p>
          <motion.button
            data-testid="hero-shop-btn"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.05, duration: 0.7 }}
            onClick={scrollToProduct}
            className="group inline-flex items-center gap-3 bg-[var(--text)] text-black px-8 py-4 uppercase tracking-widest text-sm font-bold hover:bg-[var(--accent)] hover:text-white transition-colors active:scale-95 w-fit"
          >
            Shop the drop — 1500 KSH
            <ArrowDown className="w-4 h-4 group-hover:translate-y-1 transition-transform" />
          </motion.button>
        </div>
      </div>
    </section>
  );
};
